let productMediaSwiper = null;
let zoomContainer = null;
let zoomWrapper = null;
let isZoomOpen = false;

// Cache mobile media query
const mobileMediaQuery = window.matchMedia('(max-width: 768px)');

function isMobile() {
  return mobileMediaQuery.matches;
}

function setUpProductSwipers() {
  const productMediaSelector = document.querySelector('#product-media-selector');
  const productMediaContainer = document.querySelector('#product-media-container');

  if (!productMediaContainer) return;

  const mobile = isMobile();
  let productThumbsSwiper = null;

  // The thumbnail rail is hidden on mobile, so only initialize it on desktop.
  // Initializing a Swiper inside a display:none element can produce invalid
  // measurements and is unnecessary for the mobile gallery.
  if (!mobile && productMediaSelector) {
    const thumbSlides = productMediaSelector.querySelectorAll('.swiper-slide:not(.placeholder)');
    const totalSlides = thumbSlides.length;

    if (totalSlides > 4 && totalSlides % 2 !== 0) {
      const existingPlaceholder = productMediaSelector.querySelector('.swiper-slide.placeholder');
      if (!existingPlaceholder) {
        const placeholder = createPlaceholder();
        const swiperWrapper = productMediaSelector.querySelector('.swiper-wrapper');
        swiperWrapper.appendChild(placeholder);
      }
    }

    productThumbsSwiper = new Swiper(productMediaSelector, {
      slidesPerView: 'auto',
      allowTouchMove: false,
    });
  }

  const slideCount = productMediaContainer.querySelectorAll('.swiper-slide').length;
  const productMediaCounter = productMediaContainer.querySelector('.product-media-counter');

  function updateProductMediaCounter(swiper) {
    if (!productMediaCounter || !swiper) return;
    productMediaCounter.textContent = `${swiper.realIndex + 1} / ${slideCount}`;
  }

  const swiperConfig = {
    spaceBetween: 10,
    speed: 0,
    loop: slideCount > 1,
    // Swipe gestures should work naturally on phones/tablets while desktop
    // keeps the existing click-to-zoom behavior.
    allowTouchMove: mobile,
    simulateTouch: mobile,
    on: {
      slideChange: function() {
        const activeIndex = this.realIndex;
        if (!mobile) updateThumbnailRows(activeIndex);
        updateProductMediaCounter(this);
        updateZoomSlide(activeIndex);
      },
      init: function() {
        const activeIndex = this.realIndex;
        if (!mobile) updateThumbnailRows(activeIndex);
        updateProductMediaCounter(this);
      }
    }
  };

  if (productThumbsSwiper) {
    swiperConfig.thumbs = {
      swiper: productThumbsSwiper,
    };
  }

  productMediaSwiper = new Swiper(productMediaContainer, swiperConfig);

  setupSwiperClickHandler(productMediaContainer, productMediaSwiper);
}
function createPlaceholder() {
  const placeholder = document.createElement('div');
  placeholder.className = 'swiper-slide placeholder';
  placeholder.style.visibility = 'hidden';
  placeholder.style.pointerEvents = 'none';
  return placeholder;
}

function updateThumbnailRows(selectedIndex) {
  const productMediaSelector = document.querySelector('#product-media-selector');
  const thumbSlides = productMediaSelector.querySelectorAll('.swiper-slide');
  const totalSlides = thumbSlides.length;
  
  if (totalSlides <= 4) {
    thumbSlides.forEach(slide => slide.classList.remove('swiper-slide-hidden'));
    return;
  }
  
  const row = Math.floor(selectedIndex / 2);
  const totalRows = Math.ceil(totalSlides / 2);
  
  let visibleIndices = [];
  
  if (row === totalRows - 1) {
    const lastTwoStart = totalSlides - 2;
    visibleIndices = [
      lastTwoStart, lastTwoStart + 1,
      0, 1
    ];
  } else {
    const startIndex = row * 2;
    visibleIndices = [startIndex, startIndex + 1, startIndex + 2, startIndex + 3];
  }
  
  thumbSlides.forEach((slide, index) => {
    if (visibleIndices.includes(index)) {
      slide.classList.remove('swiper-slide-hidden');
      const orderIndex = visibleIndices.indexOf(index);
      slide.style.order = orderIndex;
    } else {
      slide.classList.add('swiper-slide-hidden');
    }
  });
}

function handleInputWithCirclesSelects() {
  const selectContainers = document.querySelectorAll('.primary-select');
  selectContainers.forEach(container => {
    const select = container.querySelector('select');
    const input = container.querySelector('input');
    input.value = select.options[select.selectedIndex].textContent;
    select.addEventListener('change', function (event) {
      input.value = event.target.options[event.target.selectedIndex].textContent;
    });
  });
}

function setupSwiperClickHandler(swiperContainer, swiper) {
  swiperContainer.addEventListener('click', function(event) {
    // Don't trigger if clicking on navigation elements or thumbnails
    if (event.target.closest('#product-media-selector')) {
      return;
    }

    // Don't trigger if clicking inside zoom container or if zoom is open
    if (event.target.closest('#product-images-zoom') || isZoomOpen) {
      return;
    }

    if (isMobile()) {
      // Swiper temporarily disables click handling after a drag. This keeps a
      // completed swipe from also advancing an extra slide via the tap action.
      if (swiper.allowClick === false) return;
      swiper.slideNext();
    } else {
      // On desktop: open zoom container
      openZoomContainer(swiper.realIndex);
    }
  });
}

function setupZoomContainer() {
  zoomContainer = document.querySelector('#product-images-zoom');
  if (!zoomContainer) return;

  zoomWrapper = zoomContainer.querySelector('.product-images-zoom-wrapper');
  if (!zoomWrapper) return;

  // Close button handler
  const closeButton = zoomContainer.querySelector('.product-images-zoom-close');
  if (closeButton) {
    closeButton.addEventListener('click', function(event) {
      event.stopPropagation();
      closeZoomContainer();
    });
  }

  // Close on escape key (single listener, check state inside)
  document.addEventListener('keydown', function handleEscape(event) {
    if (event.key === 'Escape' && isZoomOpen) {
      closeZoomContainer();
    }
  });

  // Close on background click (clicking outside the wrapper/slides)
  zoomContainer.addEventListener('click', function(event) {
    // Check if click is on the container itself or outside the wrapper
    if (event.target === zoomContainer || !zoomWrapper.contains(event.target)) {
      closeZoomContainer();
    }
  });

  // Add click handlers to zoom slides to scroll to clicked image
  setupZoomSlideClickHandlers(zoomWrapper);

  // Debounced resize handler to close zoom on mobile
  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (isMobile() && isZoomOpen) {
        closeZoomContainer();
      }
    }, 150);
  }

  window.addEventListener('resize', handleResize);
  // Initial check
  if (isMobile()) {
    closeZoomContainer();
  }
}

function openZoomContainer(initialIndex) {
  if (!zoomContainer || isMobile() || isZoomOpen) return;

  isZoomOpen = true;
  zoomContainer.setAttribute('aria-hidden', 'false');
  updateZoomSlide(initialIndex);
  
  // Add class to body
  document.body.classList.add('product-zoom-open');
  
  // Prevent body scroll
  document.body.style.overflow = 'hidden';
  
  // Wait for container to be visible before scrolling
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollToZoomSlide(initialIndex);
    });
  });
}

function closeZoomContainer() {
  if (!zoomContainer || !isZoomOpen) return;

  isZoomOpen = false;
  zoomContainer.setAttribute('aria-hidden', 'true');
  
  // Remove class from body
  document.body.classList.remove('product-zoom-open');
  
  // Restore body scroll
  document.body.style.overflow = '';
}

function setupZoomSlideClickHandlers(zoomWrapper) {
  if (!zoomWrapper) return;

  // Use event delegation instead of individual listeners for better performance
  zoomWrapper.addEventListener('click', function(event) {
    const slide = event.target.closest('.product-images-zoom-slide');
    if (!slide) return;

    event.stopPropagation();
    
    const slides = zoomWrapper.querySelectorAll('.product-images-zoom-slide');
    const index = Array.from(slides).indexOf(slide);
    
    if (index !== -1) {
      scrollToZoomSlide(index);
      // Also update the main swiper to match
      if (productMediaSwiper) {
        productMediaSwiper.slideToLoop(index);
      }
    }
  });
}

function scrollToZoomSlide(index) {
  if (!zoomContainer || !zoomWrapper) return;

  const zoomSlides = zoomWrapper.querySelectorAll('.product-images-zoom-slide');
  if (!zoomSlides.length || index < 0 || index >= zoomSlides.length) return;

  const targetSlide = zoomSlides[index];
  
  // Wait for container to be visible and rendered
  requestAnimationFrame(() => {
    // Get positions relative to the scrollable container (zoomContainer)
    const containerRect = zoomContainer.getBoundingClientRect();
    const slideRect = targetSlide.getBoundingClientRect();
    
    // Calculate scroll position to center the slide in the viewport
    const scrollTop = zoomContainer.scrollTop + slideRect.top - containerRect.top - (containerRect.height / 2) + (slideRect.height / 2);
    
    // Scroll the container (which has overflow: auto)
    zoomContainer.scrollTo({
      top: scrollTop,
      left: 0,
      behavior: 'smooth'
    });

    // Update active slide
    updateZoomSlide(index);
  });
}

function updateZoomSlide(index) {
  if (!zoomWrapper) return;

  const zoomSlides = zoomWrapper.querySelectorAll('.product-images-zoom-slide');
  if (!zoomSlides.length) return;

  // Update active slide (you can add visual indicators if needed)
  zoomSlides.forEach((slide, i) => {
    if (i === index) {
      slide.setAttribute('data-active', 'true');
    } else {
      slide.removeAttribute('data-active');
    }
  });
}

function handleProductTabs() {
  const tabButtons = document.querySelectorAll('.product-title-button');
  const tabContainers = document.querySelectorAll('.product-tab');

  // Early return if no tabs found
  if (!tabButtons.length || !tabContainers.length) {
    return;
  }

  function switchTab(viewName) {
    // Update button states
    tabButtons.forEach(button => {
      const buttonView = button.getAttribute('data-view');
      const isActive = buttonView === viewName;
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Update tab visibility
    tabContainers.forEach(tab => {
      const tabView = tab.getAttribute('data-view');
      const isActive = tabView === viewName;
      // Use aria-hidden instead of aria-visible (which doesn't exist)
      tab.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      
      // Store view name as data attribute for CSS targeting if needed
      if (isActive) {
        tab.setAttribute('data-visible', 'true');
      } else {
        tab.removeAttribute('data-visible');
      }
    });
  }

  // Use event delegation for better performance
  const buttonsContainer = tabButtons[0]?.closest('.product-title-buttons');
  if (buttonsContainer) {
    buttonsContainer.addEventListener('click', function(event) {
      const button = event.target.closest('.product-title-button');
      if (button) {
        const viewName = button.getAttribute('data-view');
        switchTab(viewName);
      }
    });

    // Add keyboard support (Enter and Space)
    buttonsContainer.addEventListener('keydown', function(event) {
      const button = event.target.closest('.product-title-button');
      if (button && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        const viewName = button.getAttribute('data-view');
        switchTab(viewName);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  setUpProductSwipers();
  setupZoomContainer();
  handleInputWithCirclesSelects();
  handleProductTabs();
});
